import React from 'react';

import { aiConfigItemMessages } from '@atlaskit/editor-common/ai-messages';

import { SummarizeIcon } from '../../../../icons/prompt/summarize';
import { createInsertBelow } from '../../actions/create-actions';
import { CONFIG_ITEM_KEYS } from '../../config-item-keys';
import type {
	EditorPluginAIConfigItemFactory,
	EditorPluginAIConfigItemFactoryOptions,
} from '../../config-items';

type SmartlinkSummarizeOptions = EditorPluginAIConfigItemFactoryOptions & {
	smartlinkUrl: string;
};

type SmartlinkConfigItemFactory = (
	options: SmartlinkSummarizeOptions,
) => ReturnType<EditorPluginAIConfigItemFactory>;

export const summarizeSmartlink: SmartlinkConfigItemFactory = (
	options: SmartlinkSummarizeOptions,
) => ({
	key: CONFIG_ITEM_KEYS.SUMMARIZE_SMART_LINK,
	title: aiConfigItemMessages.summarizeWritingtitle,
	description: aiConfigItemMessages.summarizeWritingDescription,
	icon: () => <SummarizeIcon />,
	showInRefineDropdown: false,
	insertOnEmptySelection: true,
	// intentSchemaId is not being passed to the backend. it's used in `request-options-convo-ai.ts` for error logging
	intentSchemaId: 'summarize_smartlink_intent_schema.json',
	featureId: 'smartlink_summarize',
	adfPrompt: true,
	getRequestPayload: ({ locale, aiSessionId, contentAri }) => ({
		ai_feature_input: {
			feature: 'smartlink_summarize',
			feature_args: {
				smartlink_url: options.smartlinkUrl,
			},
			locale,
			ai_session_id: aiSessionId,
			content_ari: contentAri,
		},
	}),
	actions: {
		empty: [createInsertBelow({ appearance: 'primary' })],
		selection: [createInsertBelow({ appearance: 'primary' })],
	},
	getBackendModel: () => {
		return 'assistance-service';
	},
});
